export default __webpack_public_path__ + "c50cde808d154674a3a57042d63cd7b1.gltf";